import store from "@/store/index.js";
export default {
  async login(email, password) {
    const credentials = {
      email: email,
      password: password,
    };
    try {
      await store.dispatch("login", credentials);
      return store.getters.getUser;
    } catch (error) {
      return false;
    }
  },
  logout() {
    try {
      store.dispatch("logout");
      console.log("logged out!!!!");
      return true;
    } catch (error) {
      return false;
    }
  },
  isLogged() {
    return localStorage.getItem("user") != null ? true : false;
    // const user = store.getters.getUser;
    // return user !== null;
  },
  getUser() {
    const user = store.getters.getUser;
    return user;
  },
  async register(name, phone, password, confirmPassword) {
    const newUser = {
      name: name,
      phone: phone,
      password: password,
      password_confirmation: confirmPassword,
    };
    console.log("newUser", newUser);
    try {
      await store.dispatch("register", newUser);
      //console.log("resssss", store.getters.getRegResult.success);
      return store.getters.getRegResult.success;
    } catch (error) {
      return false;
    }
  },
};
